import ParameterForGraph from './ParameterForGraph'

export default class LocoSectionWithParameters {
    public locoSection = ''
    public parameters = new Array<ParameterForGraph>()
}